import { css } from 'emotion';

import { colors } from '@cobliteam/base-components/src/styles/colors';
import { fonts } from '@cobliteam/base-components/src/styles/fonts';

export const modal = css`
  padding: 20px 0;
  width: 100%;
`;

export const header = css`
  display: flex;
  margin: 0 20px 40px;
  justify-context: space-between;
`;

export const title = css`
  margin: 0 20px 20px;

  > hr {
    margin-top: 10px;
  }
`;

export const page = css`
  margin: 0 20px;

  > :last-child {
    margin-top: 20px;
  }
`;

export const reminder = css`
  padding: 15px 5px;
  margin-top: 20px;
  background-color: ${colors.custom.lightGray50Alternative3};
`;

export const reminderText = css`
  font-weight: ${fonts.weight.regular};
  color: ${colors.gray.dark};
`;

export const reminderIcon = css`
  color: ${colors.gray.dark};
`;

export const recurrenceInput = css`
  margin-top: 40px;
`;

const placeholder = css`
  content: "";
  border: none;
  margin: 30px 0 0;
`;

export const placeholderWithoutTextButton = css`
  ${placeholder} margin-bottom: 30px;
`;

export const loading = css`
  margin: 60px auto;
  width: 100%;
`;
